import React, { useMemo, useRef, useState } from "react";
import JoditEditor, { Jodit } from "jodit-react";

const EdiorJodit = (props) => {
  const { onChange, data, placeholder } = props;

  const editor = useRef(null);
  const [content, setContent] = useState("");

  // const config = useMemo(
  //   () => ({
  //     readonly: false,
  //     minHeight: 400,
  //     placeholder: placeholder || "Description",

  //   }),
  //   [placeholder]
  // );

  const config = useMemo(
    () => ({
      readonly: false,
      minHeight: 400,
      placeholder: placeholder || "Description",
      uploader: { insertImageAsBase64URI: false },
      // toolbar: true,
      // buttons: [
      //   'bold', 'italic', 'underline', 'strikethrough', '|',
      //   'ul', 'ol', '|',
      //   'outdent', 'indent', '|',
      //   'font', 'fontsize', 'brush', '|',
      //   'align', 'undo', 'redo', '|',
      //   'hr', 'eraser', 'copyformat', 'fullsize'
      // ],
      removeButtons: 'image,video,file',
      disablePlugins: 'image,imageProcessor,media,file',
    }),
    [placeholder]
  );
  

  return (
    <>
      <JoditEditor
        ref={editor}
        value={data}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onBlur={(newContent) => onChange(newContent)}
        onChange={(newContent) => { }}

      />
    </>
  );
};

export default EdiorJodit;

